import CompanyForm from './CompanyForm';

export default CompanyForm;